import { render, staticRenderFns } from "./MainAbout.vue?vue&type=template&id=2ba90a78&scoped=true"
import script from "./MainAbout.vue?vue&type=script&lang=js"
export * from "./MainAbout.vue?vue&type=script&lang=js"
import style0 from "./MainAbout.vue?vue&type=style&index=0&id=2ba90a78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba90a78",
  null
  
)

export default component.exports